import { render, staticRenderFns } from "./page013.vue?vue&type=template&id=054b5f3b&scoped=true&"
import script from "./page013.vue?vue&type=script&lang=js&"
export * from "./page013.vue?vue&type=script&lang=js&"
import style0 from "./page013.vue?vue&type=style&index=0&id=054b5f3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b5f3b",
  null
  
)

export default component.exports